// extracted by mini-css-extract-plugin
module.exports = {"saveTag":"spring-sale-promo-banner_saveTag__5BtFc","text":"spring-sale-promo-banner_text__pnpeD"};